"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetLoyaltyCodeNoLoyaltyCodesError = void 0;
var setloyaltycode_1 = __importDefault(require("./setloyaltycode"));
// Re-Export of default export is not possible, so we MUST export it named
// eslint-disable-next-line import/prefer-default-export
var SetLoyaltyCodeNoLoyaltyCodesError = /** @class */ (function (_super) {
    __extends(SetLoyaltyCodeNoLoyaltyCodesError, _super);
    function SetLoyaltyCodeNoLoyaltyCodesError(loyaltyCodesOnBasket, message) {
        var _this = _super.call(this, loyaltyCodesOnBasket, message) || this;
        Object.setPrototypeOf(_this, SetLoyaltyCodeNoLoyaltyCodesError.prototype);
        return _this;
    }
    return SetLoyaltyCodeNoLoyaltyCodesError;
}(setloyaltycode_1.default));
exports.SetLoyaltyCodeNoLoyaltyCodesError = SetLoyaltyCodeNoLoyaltyCodesError;
//# sourceMappingURL=setloyaltycodenoloyaltycodes.js.map